/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs */



/**
* | output |
* | --- |
* | "Selects the previous event closest to the current player time" |
*
* @param {Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_timeline_select_prev_event = /** @type {((inputs?: Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Timeline_Select_Prev_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionner l'evenement precedent le plus proche du temps de lecture")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählt das vorherige Ereignis aus, das dem aktuellen Spielerzeitpunkt am nächsten liegt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona l'evento precedente più vicino all'orario attuale del giocatore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбирает предыдущее событие, наиболее близкое к текущему времени игрока.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selecciona el evento anterior más cercano al tiempo del jugador actual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择距离当前玩家时间最近的上一次事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在のプレイヤー時間に最も近い前のイベントを選択します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान खिलाड़ी के समय के सबसे निकट की पिछली घटना का चयन करता है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seleciona o evento anterior mais próximo do tempo atual do jogador.")
	return /** @type {LocalizedString} */ ("Selects the previous event closest to the current player time")
});